import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.button`
  width: 100%;
  height: 3rem;
  padding: 0 0.5rem;
  border: 0;
  border-radius: 0.75rem;
  margin-top: 1.5rem;

  background: #1d62d1;
  color: #fff;

  transition: 0.3s ease-in-out;

  &:hover {
    background: ${shade(0.3, '#1d62d1')};
  }
`;
